<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    nzTitle="Send Report Email"
    [nzOkLoading]="submitLoading"
    nzWidth="650px"
    (nzOnCancel)="close()"
    (nzOnOk)="submit()"
>
    <ng-container *nzModalContent>
        <app-recipients-table #recipientsTable [currentUser]="currentUser" [type]="getRecipientType()" [editData]="selectUserEmails" [id]="id" [showLoading]="true"></app-recipients-table>
    </ng-container>
</nz-modal>
